export function allDatesFloor(): Date {
    return new Date(2000, 0, 1);
}
